import React from 'react'

const AiToolResultsLoading = ({ label, streamMsg }) => (
  <div className="stream-wrap">
    <div className="stream-card">
      <div className="stream-label">{label}</div>
      <div className="stream-dots">
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
      </div>
      <div className="stream-msg">{streamMsg}</div>
    </div>
  </div>
)

export default AiToolResultsLoading
